import { PrivateFileType } from 'types/privateFile'

interface GetBlobProps {
  body?: string | null
  method?: string
  url: string
}

interface DownloadInfo extends GetBlobProps {
  filename: string
  fileType: string
}

const sanitizeFileName = (fileName: string): string => {
  return fileName.substring(0, fileName.lastIndexOf('.')) || fileName
}

const getFileExtension = ({ file_contents = '' }: PrivateFileType): string => {
  if (!file_contents) return ''
  const urlWithoutParams = file_contents?.split('?AWS')?.[0] || ''
  const extension = urlWithoutParams.split('.').pop()
  return extension ?? ''
}

export const generateLink = (blob, filename) => {
  if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
    // Manage IE11+ & Edge
    ;(window.navigator as any).msSaveOrOpenBlob(blob, filename)
  } else {
    const url = window.URL.createObjectURL(new Blob([blob]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    //@ts-ignore
    link.parentNode.removeChild(link)
  }
}

const startDownload = async (blobProps: DownloadInfo) => {
  const { url, fileType, filename } = blobProps
  const fileName = sanitizeFileName(filename)
  if (window.RUNNING_AS_APP) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'downloadFile', url, fileName, fileType }))
  } else {
    fetch(url).then(function (t) {
      return t.blob().then((b) => {
        generateLink(b, `${fileName}.${fileType}`)
      })
    })
  }
}

export const downloadFile = async (record: PrivateFileType) => {
  const { file_contents, title } = record
  const ext = getFileExtension(record)
  const downloadInfo: DownloadInfo = {
    url: file_contents,
    filename: title,
    fileType: ext,
  }
  startDownload(downloadInfo)
}
